import * as signalR from "@microsoft/signalr";
// export default function Signalr(setSensorDataArray?: any) {
export default function Signalr(props: {
    sn?: string,
    setSensorDataArray?: Function
    setMapArray?: Function
}) {
    const {
        sn,
        setSensorDataArray,
        setMapArray
    } = props;
    // console.log("sn", sn)
    // let connection = new signalR.HubConnectionBuilder().withUrl("/api/blacklineHub").build();
    // let connection = new signalR.HubConnectionBuilder().withUrl("https://localhost:44378/api/blacklineHub").build();
    let connection = new signalR.HubConnectionBuilder().withUrl(`${process.env.REACT_APP_BASE_URL}blacklineHub`).build();
    connection.start().then(() => {
        // console.log("started");
        // connection.invoke("SubscribeToSensorData", '3571216741');
        connection.invoke("SubscribeToSensorData", sn);
    }).catch((err: any) => {
        return console.error(err.toString());
    });

    connection.on("ReceiveSensorData", (data: any) => {
        // console.log("sn: " + sn + ", data: ", data);
        // HACK 9/5/2024: 
        // setSensorDataArray((prevDataArray: any) => [...prevDataArray, data]); // Update the data array or object
        setSensorDataArray && setSensorDataArray([data]); // Update the data array or object
        setMapArray && setMapArray([data])
        // setMapArray && setMapArray((prevDataArray: any) => [...prevDataArray, data])
    });

    return () => {
        connection.stop()
    }
}